import { FunctionalComponent, h } from "@stencil/core";
import clsx from "clsx";

interface TextInputProps {
  id: string;
  name: string;
  label: string;
  hint?: string;
  error?: string;
  onInput: (event: InputEvent) => void;
  key: string | number;
  getClass: (path: string) => string;
}

export const TextInput: FunctionalComponent<TextInputProps> = (props) => {
  const {
    id,
    name,
    label,
    hint,
    error,
    key,
    onInput,
    getClass
  } = props;

  return (
    <div class={clsx("hr-field", getClass('field'))} key={key}>
      <label class={clsx("hr-label", getClass('label'))}>
        <div class={clsx("hr-label-text", getClass('labelText'))}>
          {label}
        </div>
      </label>
      <input
        id={id}
        type="text"
        name={name}
        class={clsx("hr-input hr-input-text", getClass('input'), getClass('inputText'))}
        onInput={onInput}
      />
      {hint && (
        <div class={clsx("hr-input-hint", getClass('inputHint'))}>
          {hint}
        </div>
      )}
      {error && (
        <div class={clsx("hr-input-error", getClass('inputError'))}>
          {error}
        </div>
      )}
    </div>
  )
}
